import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import $ from 'jquery'
import { useAbility } from '@/providers/';
import { ContactLocationMap } from '@/components/referral';
import { KeenIcon } from '@/components';
import { Container } from '@/components/container';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useToolbar } from '@/providers/ToolbarProvider';
import { useConfirmationModal } from '@/hooks';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { TextInput, FilterContainer, ColumnToggleDropdown, SelectInput } from '@/components/TableFilter'
import { FiltersToFormData, getAccessToken } from '@/utils';
import { createDataTableOptions, createDataTableConfig, sortData, stateCityMap } from '@/utils';
import { useAuthContext } from '@/auth';
import { goTo403 } from "@/utils/Navigation";
import { AddReferralModal } from '@/components/referral';
import referralService from '@/services/referral/referralService';
import { toast } from 'sonner';
import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';


DataTable.use(DT);
const ReferralAttorney = () => {

  const { locale, formatMessage } = useIntl();
  const navigate = useNavigate()
  const { logout, auth } = useAuthContext();
  const { ability } = useAbility();
  const { setConfig } = useToolbar();
  const { isOpen, actionId, openModal, closeModal } = useConfirmationModal();
  const [showFilter, setShowFilter] = useState(false)
  const [showMap, setShowMap] = useState(true)
  const [filterData, setFilterData] = useState({
    from_date: null,
    to_date: null,
    date_range: null,
    state: null,
    city: null,
    zip: null,
    name: 'provider', // provider
    // speciality: specialties, // Speciality
    // speciality: "not_null",
  });
  const tableRef = useRef(null);
  const API_URL = import.meta.env.VITE_APP_BASE_URL;
  const token = getAccessToken();
  const filterRef = useRef(filterData);
  const formikRef = useRef();
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectionSource, setSelectionSource] = useState(null);
  const [referralModal, setReferralModal] = useState(false);
  const [referralLoading, setReferralLoading] = useState(false)
  const selectedContactRef = useRef(null);

  const stateOptions = sortData(
    Object.keys(stateCityMap).map((state) => ({
      label: state,
      value: state,
    })),
    { mode: "alpha", key: "label" }
  );

  // useEffect(() => {
  //   const roles = auth?.user?.roles || [];
  //   const permission = auth?.user?.permissions || [];

  //   const isSuperAdmin = roles.includes('super-admin');
  //   const isAdmin = permission.includes('is_admin_access');
  //   const isReferralAttorney = auth?.user?.referral_attorney === 1;

  //   if (!isSuperAdmin && !isReferralAttorney && !isAdmin) {
  //     navigate('/');
  //   }
  // }, [auth?.user]);


  useEffect(() => {
    filterRef.current = filterData;
  }, [filterData]);

  useEffect(() => {
    selectedContactRef.current = selectedContact;
  }, [selectedContact]);

  useEffect(() => {
    if (selectionSource === 'map' && selectedContact?.id) {
      const row = document.getElementById(`row-${selectedContact.id}`);
      if (row) {
        row.classList.add('transition-all', 'duration-500', 'ease-in-out', '!bg-[#006ae612]', 'opacity-100');

        row.scrollIntoView({ behavior: 'smooth', block: 'center' });

        setTimeout(() => {
          row.classList.remove('!bg-[#006ae612]', 'opacity-100');
        }, 3000);
      }
    }
    if (selectionSource === 'table' && selectedContact?.id) {
      const mapSection = document.querySelector('.contact-location-map');
      if (mapSection) {
        mapSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [selectedContact, selectionSource]);


  const columns = useMemo(() => ([
    // {
    //   title: 'S#',
    //   name: 'serial',
    //   data: null,
    //orderable: true,se,
    //   render: (data, type, row, meta) => meta.row + 1,
    // },
    {
      title: formatMessage({ id: 'SPECIALTY' }),
      data: 'speciality',
      name: 'speciality',
    },
    {
      title: formatMessage({ id: 'STATE' }),
      data: 'address',
      name: 'state',
      orderable: true,
      render: function (data, type, row) {
        const addr = row.address?.[0];
        return addr?.state || '-';
      }
    },
    {
      title: formatMessage({ id: 'CITY' }),
      data: 'address',
      name: 'city',
      orderable: true,
      render: function (data, type, row) {
        const addr = row.address?.[0];
        return addr?.city || '-';
      }
    },
    {
      title: formatMessage({ id: 'ZIP' }),
      data: 'address',
      name: 'zip',
      orderable: true,
      render: function (data, type, row) {
        const addr = row.address?.[0];
        return addr?.zip || '-';
      }
    },
    // --- Extended Columns ---
    // {
    //   title: formatMessage({ id: 'PROVIDER NAME' }),
    //   data: null,
    //   name: 'provider_name',
    //   render: function (data, type, row) {
    //     return `${row.first_name || ''} ${row.middle_name || ''} ${row.last_name || ''}`.trim() || '-';
    //   }
    // },
    // {
    //   title: formatMessage({ id: 'BUSINESS NAME' }),
    //   data: 'business_name',
    //   name: 'business_name',
    // },
    // {
    //   title: formatMessage({ id: 'EMAIL' }),
    //   data: 'email',
    //   name: 'email',
    // },
    // {
    //   title: formatMessage({ id: 'HOME PHONE' }),
    //   data: 'phones',
    //   name: 'home_number',
    //   render: function (data, type, row) {
    //     const phone = row.phones?.[0];
    //     return phone?.number || '-';
    //   }
    // },
    // {
    //   title: formatMessage({ id: 'ASSIGNED TO' }),
    //   data: 'assigned_to',
    //   name: 'assigned_to',
    //   render: function (data, type, row) {
    //     return row.assigned_to?.map(u => `${u.first_name} ${u.last_name}`.trim()).join(', ') || '-';
    //   }
    // },
    // {
    //   title: formatMessage({ id: 'CREATED BY' }),
    //   data: 'createdBy',
    //   name: 'created_by',
    //   render: function (data, type, row) {
    //     return row.createdBy ? `${row.createdBy.first_name} ${row.createdBy.last_name}` : '-';
    //   }
    // },
    // {
    //   title: formatMessage({ id: 'INVOICE TEMPLATE' }),
    //   data: 'invoiceTemplate',
    //   name: 'invoice_template',
    //   render: function (data, type, row) {
    //     return row.invoiceTemplate?.name || '-';
    //   }
    // }
  ]), [locale, formatMessage]);

  const defaultVisibleColumns = useMemo(() => ([
    // 'serial',
    'speciality',
    'city',
    'state',
    'zip',
  ]), []);

  const customDataSrc = useCallback((transformedData) => {
    console.log('Custom dataSrc called with transformed data:', transformedData);
    setContacts(transformedData.data);  // Set the contacts data to state
  }, []);
  const ajaxConfig = useMemo(() => (
    createDataTableConfig('/contacts/data_table_list', filterRef, token, logout, customDataSrc)
  ), [token, logout, customDataSrc]);

  // const ajaxConfig = {
  //   method: 'POST',
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  //   url: `${API_URL}/contacts/data_table_list`,
  //   xhrFields: {
  //     withCredentials: true
  //   },
  //   data(dt) {
  //     const activeFilters = filterRef.current;

  //     FiltersToFormData(activeFilters, dt);

  //     console.log('Final data sent to DataTable:', dt);
  //     return dt;
  //   },
  //   dataSrc: function (json) {
  //     console.log('===?', json);
  //     setContacts(json.data);
  //     return json.data;
  //   },
  //   error: function (xhr, error, thrown) {
  //     if (xhr.status === 401) {
  //       logout();
  //     } else if (xhr.status === 403) {
  //       goTo403()
  //     }
  //   }
  // }

  const options = useMemo(() => createDataTableOptions({
    order: [[0, 'desc']],
    initComplete: function () {
      const api = this.api();
      api.columns().every(function () {
        const col = this;
        const name = col.settings()[0].aoColumns[col.index()].name;
        if (name && !defaultVisibleColumns.includes(name)) {
          col.visible(false);
        }
      });
    },
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({ page: 'current' }).data();
      const nodes = api.rows({ page: 'current' }).nodes();

      rows.each((row, i) => {
        const el = nodes[i];
        el.id = `row-${row.id}`;

        const addr = row.address?.[0];
        const fullAddress = addr
          ? `${addr.address || ''}, ${addr.city || ''}, ${addr.state || ''}, ${addr.zip || ''}`
          : '';

        // 👇 Normalized contact object for map
        const contactForMap = {
          id: row.id,
          name: `${row.first_name || ''} ${row.last_name || ''}`,
          address: fullAddress,
          speciality: row.speciality,
        };

        $(el)
          .off('click')
          .on('click', () => {
            setSelectionSource('table')
            setSelectedContact(contactForMap)
          });

        // Highlight logic
        if (selectedContactRef.current?.id === row.id) {
          el.classList.add('bg-yellow-100');
        } else {
          el.classList.remove('bg-yellow-100');
        }

        const contactContainer = document.getElementById(`contact-cell-${row.id}`);
        if (contactContainer) {
          if (!contactContainer._reactRoot) {
            contactContainer._reactRoot = createRoot(contactContainer);
          }
          contactContainer._reactRoot.render(renderContactName(row));
        }

        const actionContainer = document.getElementById(`action-cell-${row.id}`);
        if (actionContainer) {
          if (!actionContainer._reactRoot) {
            actionContainer._reactRoot = createRoot(actionContainer);
          }
          actionContainer._reactRoot.render(renderCustomActions(row));
        }
      });
    }
  }), [defaultVisibleColumns]);

  const resetFilters = () => {
    const cleared = {
      from_date: null,
      to_date: null,
      date_range: null,
      state: null,
      city: null,
      zip: null,
      name: 'provider',
      // speciality: "not_null",
    };

    setFilterData(cleared);
    filterRef.current = cleared;
    refresh()
  };

  const handleFilterChange = (key, val) => {
    setFilterData((prev) => {
      const updated = { ...prev, [key]: val };
      filterRef.current = updated;
      //console.log('updated',updated)
      return updated;
    });
  };

  const handleToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const handleToggleMap = () => {
    setShowMap(prev => !prev)
  }

  const refresh = () => {
    const table = tableRef.current.dt();
    table.ajax.reload();
  };

  const renderContactName = (row) => {
    if (!row.contact) {
      return <span>-</span>;
    }
    const fullName = row.first_name + ' ' + row.last_name;
    const { id } = row;
    // onClick={() => {handleNavigateConatct(id)}}
    return (
      <span className='cursor-pointer link'>{fullName}</span>
    )
  }

  // Custom Render Func For Jquery Data tbale
  const renderCustomActions = (row) => {
    const { id } = row;

    return (
      <DropdownMenu>
        {/* {(canEditContact ||canDeleteContact ) && ( */}
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="text-gray-600">
            <KeenIcon icon="dots-vertical" className="text-[18px]" />
          </Button>
        </DropdownMenuTrigger>
        {/* )} */}
        <DropdownMenuContent align="end" className="w-42">
          {/* <Can I="handle" a="contact" ability={ability}>
          </Can> */}
          <DropdownMenuItem onClick={() => handleEdit(id)}>
            <KeenIcon icon="entrance-left" className="mr-0.5 h-4 w-4 cursor-pointer" /> Request Referral
          </DropdownMenuItem>
          {/* <Can I="delete" a="contact" ability={ability}>
          </Can> */}
          {/* <DropdownMenuItem onClick={() => openModal(id)} className="text-red-600 cusror-pointer">
              <KeenIcon icon="trash" className="mr-0.5 h-4 w-4" /> Delete
            </DropdownMenuItem> */}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  const setNestedValue = (obj, path, value) => {
    const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value;
      } else {
        if (!current[key]) current[key] = isNaN(keys[index + 1]) ? {} : [];
        current = current[key];
      }
    });
  };


  const handleAddReferral = async (values, resetForm, setErrors) => {
    console.log('setErrors', setErrors);
    console.log('values', values);
    // return
    setReferralLoading(true);
    const formData = new FormData();

    // Basic fields
    formData.append('first_name', values.first_name ?? '');
    formData.append('last_name', values.last_name ?? '');
    formData.append('contact_type_id', values.contact_type_id ?? '');
    formData.append('dob', values.dob);
    formData.append('do_injury', values.do_injury);
    formData.append('speciality', values.speciality ?? '');
    formData.append('doctor_name', values.original_doctor_name ?? '');
    formData.append('note', values.note ?? '');

    // Phone number
    if (Array.isArray(values.phone_number) && values.phone_number.length > 0) {
      const phone = values.phone_number[0];
      formData.append('phone_number[title]', phone.title ?? '');
      formData.append('phone_number[number]', phone.number ?? '');
    }

    // Address
    formData.append('address[add_type]', values.add_type ?? 'Home');
    formData.append('address[address]', values.address ?? '');
    formData.append('address[city]', values.city ?? '');
    formData.append('address[state]', values.state ?? '');
    formData.append('address[zip]', values.zip ?? '');

    // Documents
    if (Array.isArray(values.documents)) {
      values.documents.forEach((file, index) => {
        formData.append(`file_upload[${index}]`, file);
      });
    }

    try {
      const { status } = await referralService.createReffralContact(formData);
      if (status) {
        setReferralModal(false);
        toast.success(formatMessage({ id: 'referral.referral_added' }), {
          description: formatMessage({ id: 'referral.referral_added_successfully' }),
        });
      }
    } catch (error) {
      console.error('Error:', error);
      if (error.message === '422 Unprocessable Entity. Validation failed.') {
        const responseErrors = error.errors || {};
        const formattedErrors = {};

        Object.entries(responseErrors).forEach(([key, value]) => {
          const correctedKey = key === 'phone_number.number' ? 'phone_number[0].number' : key;
          setNestedValue(formattedErrors, correctedKey, value);
        });

        console.log('formattedErrors', formattedErrors);
        setErrors(formattedErrors);

        toast.warning(formatMessage({ id: 'referral.validation_error' }), {
          description: formatMessage({ id: 'referral.validation_message' }),
        });
        return
      }
      toast.error(formatMessage({ id: 'referral.failed_to_add_referral' }), {
        description: formatMessage({ id: 'referral.error_message' }),
      });
    } finally {
      setReferralLoading(false);
    }
  };


  useEffect(() => {
    setConfig({
      actions: (
        <>
          <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
            <KeenIcon icon="filter" className="w-fit btn-icon" />
            {showFilter ? <FormattedMessage id="FILTERS.HIDE" /> : <FormattedMessage id="FILTERS.SHOW" />}
          </button>
          <button className='text-xs btn btn-sm btn-light btn-outline' onClick={() => setReferralModal(true)}>
            <KeenIcon icon="plus" className="w-fit btn-icon" />
            <FormattedMessage id="REFERRAL.ADD" />
          </button>
        </>
      ),
    });

    return () => setConfig(null);
  }, [showFilter]);

  return (
    <>
      <Container>
        {/* Filters */}
        <FilterContainer
          show={showFilter}
          onApply={() => refresh()}
          onReset={resetFilters}
        >

          <SelectInput
            label={formatMessage({ id: 'STATE' })}
            value={filterData.state}
            onChange={(val) => handleFilterChange('state', val)}
            staticOptions={stateOptions}
            customClass="sm:w-[32%] w-full"
          />
          {/* <TextInput
            label={formatMessage({ id: 'STATE' })}
            value={filterData.state}
            onChange={(val) => handleFilterChange('state', val)}
            placeholder={formatMessage({ id: 'FILTERS.ENTER_STATE' })}
            customClass="sm:w-[32%] w-full"
          /> */}

          <TextInput
            label={formatMessage({ id: 'CITY' })}
            value={filterData.city}
            onChange={(val) => handleFilterChange('city', val)}
            placeholder={formatMessage({ id: 'FILTERS.ENTER_CITY' })}
            customClass="sm:w-[32%] w-full"
          />


          <TextInput
            label={formatMessage({ id: 'ZIP' })}
            value={filterData.zip}
            onChange={(val) => handleFilterChange('zip', val)}
            placeholder={formatMessage({ id: 'FILTERS.ENTER_ZIP' })}
            customClass="w-[32%] no-spinner"
            type="number"
          />
        </FilterContainer>

        {/* Map */}
        <div className='min-w-full my-4 card'>
          <div className="card-header !block">
            <div className='flex flex-wrap items-center justify-between'>
              <h3 className="card-title"><FormattedMessage id="PROVIDERS.LOCATION" /></h3>

              <div className='flex flex-wrap items-center gap-2'>
                <button className='text-xs btn btn-sm btn-light btn-outline' onClick={handleToggleMap}>
                  <KeenIcon icon={showMap ? 'eye-slash' : 'eye'} className="w-fit btn-icon" />
                  {showMap ? <FormattedMessage id="MAP.COLLAPSE" /> : <FormattedMessage id="MAP.EXPAND" />}
                </button>
              </div>
            </div>
          </div>
          <div className='py-3 mx-3 contact-location-map'>
            <ContactLocationMap
              contacts={contacts}
              height={showMap ? '600px' : '0'}
              isCollapsed={showMap}
              selectedContact={selectedContact}
              setSelectedContact={setSelectedContact}
              setSelectionSource={setSelectionSource}
            />
          </div>
        </div>

        {/* Contact List */}
        <div className="min-w-full mb-4 card">
          <div className="card-header !block">
            <div className='flex flex-wrap items-center justify-between'>
              <div className='flex items-center gap-1'>
                <ColumnToggleDropdown tableRef={tableRef} columns={columns} defaultVisibleColumns={defaultVisibleColumns} />
                {/* <h3 className="card-title"><FormattedMessage id="PROVIDERS" /></h3> */}
              </div>

            </div>
          </div>

          <DataTable
            id="attorney-table"
            ajax={ajaxConfig}
            columns={columns}
            options={options}
            ref={tableRef}
            key={locale}
          />
        </div>

        <AddReferralModal
          show={referralModal}
          onClose={() => setReferralModal(false)}
          title={formatMessage({ id: 'add_referral.add_referral' })}
          onConfirm={handleAddReferral}
          loading={referralLoading}
          setLoading={setReferralLoading}
          ref={formikRef}
        />
        {/* <ConfirmationModal
          show={isOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this Contact? This action is permanent and cannot be undone."
          title="Are You Sure?"
        /> */}
      </Container>
    </>
  )
}

export { ReferralAttorney }
